/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import _ from "lodash";
export class ObjectUtility {
    static assignOnObjectPath(path, value, root) {
        let segments = path.split('.');
        let currentObj = root || window;
        if (segments.length > 0 && segments[0].toLowerCase() === 'window') {
            segments = segments.slice(1);
        }
        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];
            if (!Object.prototype.hasOwnProperty.call(currentObj, segment)) {
                // @ts-ignore
                currentObj[segment] = {};
            }
            if (i == segments.length - 1) {
                // @ts-ignore
                currentObj[segment] = value;
                break;
            }
            // @ts-ignore
            currentObj = currentObj[segment];
        }
    }
    static getFromObjectPath(path, root) {
        try {
            // @ts-ignore
            let value = undefined;
            let segments = path.split('.');
            let currentObj = root || window;
            if (segments.length > 0 && segments[0].toLowerCase() === 'window') {
                segments = segments.slice(1);
            }
            let currentPath = '';
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i];
                if (!Object.prototype.hasOwnProperty.call(currentObj, segment)) {
                    break;
                }
                currentPath += (i > 0 ? '.' : '') + segment;
                if (i == segments.length - 1) {
                    // @ts-ignore
                    value = currentObj[segment];
                    break;
                }
                // @ts-ignore
                currentObj = currentObj[segment];
            }
            return value;
        }
        catch (e) {
            console.error(`Could not get value from given path '${path}'`, e);
            return undefined;
        }
    }
    static buildObjectFromPath(path) {
        const segments = path.split('.').filter(segment => segment);
        const root = {};
        let current = root;
        segments.forEach(segment => {
            // @ts-ignore
            current[segment] = {};
            // @ts-ignore
            current = current[segment];
        });
        return root;
    }
    static serialize(value) {
        try {
            return JSON.stringify(value);
        }
        catch (e) {
            console.error(e);
            return JSON.stringify(undefined);
        }
    }
    static deserialize(value) {
        const lowerCaseValue = value === null || value === void 0 ? void 0 : value.toLowerCase();
        if (lowerCaseValue === 'null') {
            return null;
        }
        if (lowerCaseValue === 'undefined') {
            return undefined;
        }
        try {
            return JSON.parse(value);
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }
    static deepClone(value) {
        if (!value) {
            return value;
        }
        return ObjectUtility.deserialize(ObjectUtility.serialize(value));
    }
    static isDefined(value) {
        return typeof value !== 'undefined' && value !== null;
    }
    static merge(obj1, obj2) {
        return _.merge({}, obj1, obj2);
    }
    static mergeKeepingDefinedValues(obj1, obj2) {
        return _.mergeWith({}, obj1, obj2, (objValue, srcValue) => {
            // If the property in the target object is undefined, use the value from the source object
            if (objValue === undefined) {
                return srcValue;
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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